type TCta = {
  label?: string;
  link?: string;
  channel: string;
};

export function getCTA(links: TCta[], channel: 'web' | 'app') {
  return links.find(item => item.channel.toLowerCase().includes(channel));
}
